import { render, staticRenderFns } from "./DialogId5.vue?vue&type=template&id=3e8072ea&scoped=true&"
import script from "./DialogId5.vue?vue&type=script&lang=js&"
export * from "./DialogId5.vue?vue&type=script&lang=js&"
import style0 from "./DialogId5.vue?vue&type=style&index=0&id=3e8072ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8072ea",
  null
  
)

export default component.exports